
<template>
	<div class="page-container">

		<HeaderLayout :pagecode="pagecode" :subpagecode="subpagecode"  @eventProblemCode="updateProblemCode"></HeaderLayout>>
		
		<div class="content">
			<div class="main-content">
				
				 <div class="main-1">
					  <ul>
					  	   <li class="active"  @click="updateTab('info')">기본정보 수정</li>
						   <li  @click="updateTab('pass')">비밀번호 변경</li>
					  </ul>
					  <div style="clear:both"></div>
				</div>
				<form  id="addsubmitForm" action="memberProc/updateMember"  novalidate @submit="formSubmit">
				<div class="from-box" v-if="infoView">
					<div class='form-group'>   
					    <label class="text-label">아이디</label>
						<div class="text-input" >
							{{info.uid}}
						</div>
					</div>
					

					<div class='form-group'>   
						<label class="text-label">이름</label>
						<div class="text-input" >
							 <input :required="true" placeholder="이름을 입력해주세요" type="text" autocomplete="off" name="name"  v-model="info.name" id="name"/>
						</div>
						<div class="md-error-box">이름을 입력하세요</div>
					</div>
					<div class='form-group'>   
						<label class="text-label">연락처</label>
						<div class="text-input" >
						<input :required="true" placeholder="연락처를 입력해주세요" type="text" autocomplete="off" name="pcs"  v-model="info.pcs" id="pcs"/>
						</div>
						<div class="md-error-box">연락처를 입력하세요</div>
					</div>
				    <div class='form-group'>   
						<label class="text-label">이메일</label>
						<div class="text-select">
							<input :required="true" type="text" autocomplete="off" v-model="emailPre" name="emailpree" id="emailpree">
							<span class="text-a">@</span>
							<select :required="true"  name="emailtail" id="emailtail" v-model="emailTail">
								 <option value="">선택</option>
								 <option value="naver.com">naver.com</option>
								 <option value="gmail.com">gmail.com</option>
								 <option value="hanmail.net">hanmail.net</option>
								 <option value="nate.com">nate.com</option>
								 <option value="paran.com">paran.com</option>
							</select>
						</div>
						<div class="md-warning-box" id="userEmail-warning">{{userEmailMessage}}</div>
						<div class="md-error-box">이메일을 입력하세요</div>
					</div>
					<!--div style='height:10px;'></div>
					<div class='form-group'>   
						<label class="text-label">주소</label>
						<div class="text-select-1" >
				  			<input :required="true" style="width:70%;max-width:70%;" type="text" v-model="address1" autocomplete="off" name="addr1" id="addr1">
							<span class="box-adder" @click="openPost()">우편번호</span>
						</div>
						<div class="md-error-box" style='margin-top:5px;'>주소를 입력하세요</div>
						
					</div>
					<div class='form-group'>   
						<div class="text-input" >
				  			<input :required="true" type="text" autocomplete="off" name="addr2"  v-model="address2" id="addr2" placeholder="상세주소를 입력해주세요.">
						</div>
						<div class="md-error-box">상세주소를 입력하세요</div>
					</div-->
						
					<div style='height:10px;'></div>
					<div class="box-button">
				        <md-button class="md-raised md-accent"  style='width:100%;margin:0;height:50px;' type="submit">수정하기</md-button>
					</div>
				</div>
				</form>
				<form  id="passForm" action="memberProc/updatePassword"  novalidate @submit="formSubmitPass">
				<div class="from-box" v-if="!infoView">
					<div class='form-group'>   
						<label class="text-label">현재 패스워드</label>
						<div class="text-input" >
							<input :required="true" type="password" name="nowupass" id="nowupass"/>
						</div>
						<div class="md-error-box">현재 패스워드를 입력하세요</div>
					</div>
					
					<div class='form-group'>   
						<label class="text-label">새 패스워드</label>
						<div class="text-input" >
							<input :required="true" :option="'userpw'" type="password" name="upass" id="upass"/>
						</div>
						<div class="md-warning-box">8~15자의 영문자와 숫자 특수문자의 조합</div>
						<div class="md-error-box">새 패스워드를 입력하세요</div>
					</div>
					<div style='height:10px;'></div>
					<div class='form-group'>   
						<label class="text-label">새 패스워드확인</label>
						<div class="text-input" >
							<input :required="true"   :match="'#upass'" type="password" name="repass" id="repass" />
						</div>
						<div class="md-warning-box fail-warning-hide">비밀번호와 비밀번호확인이 일치하지 않습니다</div>
						<div class="md-error-box">새 패스워드확인을 입력하세요</div>
					</div>
					<div style='height:10px;'></div>
					<div class="box-button">
				        <md-button class="md-raised md-accent"  style='width:100%;margin:0;height:50px;' type="submit">수정하기</md-button>
					</div>
				</div>
				</form>
			</div>	
		</div>
		<FooterLayout></FooterLayout>
	</div>
</template>

<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'
export default {
  name: 'MemberUpdateMyinfo',
  components: {
		  HeaderLayout,
		  FooterLayout,
  },
  //watch: {
	// address2(val) {
	//	this.address1 = $('#addr1').val();
	// }
  //},
  data () {
	
	return {
		pagecode:'mypage',
		subpagecode:'member',
	    info:{},
		userEmail:null,
	    userEmailMessage:'',
	    userEmailFlag:false,
	    userEmailSend:false,
		infoView:true,
		emailPre:'',
		emailTail:'',
		//address1:'',
		//address2:'',
	   
   }
  },
  created: function() {
	  if(!sessionStorage.getItem('memberkey')) {
		  this.$router.push({path:'/member/login'});
		  return;
	  }
	  this.getData();
	  
  },
  methods: {
	  updateProblemCode(code) {
		this.$router.push({path:'/member/myAi/upd'});

	  },
	  getData() {  
		this.info = sessionStorage.getObject('memberInfo')	
		//console.log(this.info);
		var emails = this.info.email.split('@');
		this.emailPre = emails[0];
		this.emailTail = emails[1];
		//this.address1 = this.info.address1;
		//this.address2 = this.info.address2;
	  },	
	  focus() {
		$('.md-field').css('border-bottom','none');
		$('.md-input').css('outline','none').css('border-bottom','none');
	  },
	  formSubmitPass(e) {

		 var obj = this;
		var $f = $('#passForm');
		this.$form.validate($f,e,function(response){
			
				obj.updateInfo(response)
		});
	  },
	   updateInfo(resp) {

		  var result = resp.result;
		  var params = {};
		  switch(result) {
			  case 'succ':
				params.content = '비밀번호가  변경되었습니다';	
			  break;
			  case 'wrongpass':
				params.content = '잘못된 현재 비밀번호 입니다';	
			  break;
			  default:
				params.content = '시스템 에러';	
			  break;
			  
		  }
		  this.$eventBus.$emit('dialogOpen',params);
		  
	  },
	  formSubmit(e) {
		  var obj = this;
		var $f = $('#addsubmitForm');
		this.$form.validate($f,e,function(response){
				obj.completeJoin(response)
		
		});
		
	  },
	  completeJoin(resp) {
		  var result = resp.result;
		  var params = {};
		  var obj = this;
		  switch(result) {
			  case 'succ':
			  	sessionStorage.setObject('memberInfo',resp.userInfo);
				params.content = '회원정보가 수정되었습니다';
				//params.doAction = function() {
				//	obj.$router.push({path:'/'});
				//}
			  break;
			  case 'doubleEmail':
				params.content = '중복된 이메일이 존재합니다';
				
			  break;
			  default:
				params.content = '시스템 에러';	
			  break;
			  
		  }
		  this.$eventBus.$emit('dialogOpen',params);
		  
	  },
	   openPost() {

		execDaumPostcode();
	  },
	  updateTab(cmd) {
		 $('.main-1 ul li').removeClass('active');
		 if(cmd=='info') {
			 $('.main-1 ul li:first-child').addClass('active');
			 this.infoView = true;
			 this.getData();
		 } else {
			 $('.main-1 ul li:last-child').addClass('active');
			  this.infoView = false;
		 }
	  }
	 

  },
  mounted: function() {

	$('.page-container').css('min-height',$(window).height());
	$('.text-input input').focus(function() {
		$(this).parent().addClass('md-focused');
	});
	$('.text-input input').blur(function() {
		$(this).parent().removeClass('md-focused');
	});
	$('.text-select input,select').focus(function() {
		$(this).addClass('md-focused');
	});
	$('.text-select input,select').blur(function() {
		$(this).removeClass('md-focused');
	});
	
	$('.text-select-1 input').focus(function() {
		$(this).parent().addClass('md-focused');
	});
	$('.text-select-1 input').blur(function() {
		$(this).parent().removeClass('md-focused');
	});
	
	
	
  },
  updated() {
	$('.text-input input').focus(function() {
		$(this).parent().addClass('md-focused');
	});
	$('.text-input input').blur(function() {
		$(this).parent().removeClass('md-focused');
	});
	
  }

}
</script>

<style lang="scss" scoped>

.page-container {
	width:100%;
	background:#fff;
	margin:0;
	min-height:calc(100vh);
	.content {
		width:100%;
		height:auto;
		padding:150px 0 100px; 
		font-family: 'Nanum Gothic', sans-serif;
		background:#fff;
		.main-content {
			width:400px;
			margin:0 auto;
			.main-1      {
		      padding:12px 0 15px 0;
			  	 ul     {
				      li     {
					      font-size:13px;
						  color:#A0A0A0;
						  width:47%;
						  padding:7px 0;
						  cursor:pointer;
						  text-align:center;
						  border-radius:20px;
						  background:#fff;
						  border:1px solid #C7C7C7;
						  color:#C7C7C7;
						  &:last-child     {
						         float:right;
						 }
						  &:first-child     {
						         float:left; 
								 
						  }
					  }
					  li.active {
							background:#3D79FF;
							color:#fff;
						  
						  
					  }
				  }
		    }
			.text-name {
				font-size:26px;
				font-weight:normal;
				color:#414141;
				line-height:100%;
				margin-bottom:0;
			}
			.text-name-1	{
						margin-top:15px;
						color:#B3B3B3;
						font-size:11px;
						padding-bottom:30px;
						line-height:13pt;
			}
			.text-label			{
						color:#B3B3B3;
						font-size:13px;
						
			}
			.text-input		     {
						padding:12px 0;
						border-bottom:1px solid #EDEDED;
						margin-bottom:12px;
						input			{
								width:100%;
								border:none;
								outline:none;
								color:#000;
						}
						
			}
		
			.text-input.md-focused {
				border-bottom:2px solid #3D79FE;
	
			}
			.text-select		{
						padding:10px 0;
						width:100%;
						input      {
								padding:13px 0;
								border:none;
								outline:none;
								border-bottom:1px solid #EDEDED;
								width:45%;
						}
						input.md-focused {
							border-bottom:2px solid #3D79FE;
						}
						.text-a      {
								width:10%;
								font-size:18px;
								display:inline-block;
								text-align:center;
						}
						select      {
								padding:13px 0;
								border:none;
								outline:none;
								border-bottom:1px solid #DEDEDE;
								width:45%;
								font-size:12px;
								
						}
						select.md-focused {
							border-bottom:2px solid #3D79FE;
						}
			}
			.text-select-1  {
						padding:20px 0;
						border-bottom:1px solid #EDEDED;
						width:100%;
						position:relative;
						input  {
						         width:70%;
								 border:none;
								 outline:none;
						}
						.box-adder		{
								 width:90px;
								 padding:5px;
								 border-radius:20px;
								 border:1px solid #DEDEDE;
								 display:inline-block;
								 text-align:center;
								 font-size:12px;
								 position:absolute;
								 right:5px;
								 cursor:pointer;
								
						}
			}
			.text-select-1.md-focused {
				border-bottom:2px solid #3D79FE;
	
			}
			.text-box-input          {
						padding:12px 0;
						border-bottom:1px solid #EDEDED;
						margin-bottom:12px;
						input          {
								width:100%;
								border:none;
								outline:none;
								color:#000;
						}
			}
			.box-check       {
					  margin-bottom:12px;
					  font-size:13px;
					  input      {
					  		  width:15px;
							  height:15px;
							  vertical-align:-2px;
							  margin-right:5px;
							  word-spacing:-3px; 
					  }
					  .text-check     {
					  		  color:#3D79FE;
							  cursor:pointer;
					  }
					  .midder-border      {
					           width:100%;
							   .border-1    {
							   			display:inline-block;
										width:11%;
										height:1px;
										background:#3D79FE;
										position:absolute;
										left:47px;
										
							   }
							    .border-2    {
							   			display:inline-block;
										width:30%;
										height:1px;
										background:#3D79FE;
										position:absolute;
										left:110px;
										
							   }
					  }
			}
			.box-button        {
			          width:100%;
					  margin-top:20px;
					  button      {
							width:100%;
						    padding:10px;
							background:#3D79FE;
					        color:#fff;
							border-radius:30px;
							border:none;
							outline:none;
							font-size:13px;
					  }
			}
			.box-border        {
					 width:100%;
					 margin:30px auto;
					 ul           {
					      display:flex;
					      li         {
						          width:42%;
			                      border-bottom:1px solid #CBCBCB;
								  position:relative;
								  text-align:center;
								  &:nth-child(2)        {
								           width:16%;
										   border-bottom:none;
										  .text-OR     {
										           position:absolute;
												   top:-12px;
												   width:20%;
												   left:13px;
										  }
								  }
					            
						   }
					}
			}
			.box-button-img         {
			           width:100%;
					   margin-bottom:20px;
					   button      {
							width:100%;
						    padding:11px;
					        color:#fff;
							border-radius:30px;
							border:none;
							outline:none;
							font-size:13px;
							text-align:center;
							line-height:20px;
							img     {
							     margin-right:5px;
							}
					  }
					  &:last-child     {
					         margin-bottom:35px;
					         button      {
							       color:#3B1F1F; 
								   font-weight:bold;
							 }
					  }
			}
		}
	}
	.screen-layout {
		width:100%;
		height:calc(100vh);
		background:rgba(0,0,0,.7);
		position:fixed;
		top:0;
		left:0;
		z-index:100000;
		.agreeLayout {
			width:700px;
			margin:150px auto 0 auto;
			background:#fff;
			padding:20px;
			position:relative;
			.close-box {
				position:absolute;
				top:5px;
				right:10px;
				text-align:center;
				line-height:40px;
				font-size:20pt;
				cursor:pointer;
				z-index:10000;
			}
			h2 {
				margin:10px 0 10px 0;
				font-size:16pt;
				text-align:center;
			}
			.agreeText {
				height:500px;
				overflow-x:hidden;
				overflow-y:auto;
				padding:10px;
				border:solid 1px #dcdcdc;
			}
		}
	}
	
}

</style>